/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_MODELS } from '../../actions.type'
import {
  CREATE_MODEL,
  REMOVE_MODEL,
  SET_MODEL_ALL_REQUEST,
  SET_MODEL_ALL_VALUE,
  UPDATE_MODEL
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  modelAllValue: (state) => state.all.value,
  modelAllRequest: (state) => state.all.request,
  modelAllById: (state) => keyBy(state.all.value, 'id')
}

const actions = {
  // TODO: Разобраться с лишними вызовами API в FETCH_MODELS
  // Проблема: делаются дополнительные запросы к equipment, zone, contract
  // которые дублируют другие fetch-actions и создают избыточную нагрузку.
  // Рекомендация: убрать дополнительные запросы и использовать computed/getters
  // для вычисления связей между моделями и оборудованием/зонами/контрактами.
  async [FETCH_MODELS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('model', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_MODEL_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_MODEL_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      const { data: equipments } = await Vue.axios.get('equipment')
      const equipmentsId = equipments
        .filter((equipment) =>
          data.some((model) => model.id === equipment.model.id)
        )
        .map((equipment) => ({ id: equipment.id }))

      const { data: zones } = await Vue.axios.get('zone')
      const zonesId = zones
        .filter((zone) =>
          data.some((model) => zone.models.some((m) => m.id === model.id))
        )
        .map((zone) => ({ id: zone.id }))

      const { data: contracts } = await Vue.axios.get('contract')
      const contractsId = contracts
        .filter((contract) =>
          data.some((model) => contract.models.some((m) => m.id === model.id))
        )
        .map((contract) => ({ id: contract.id }))

      const editedData = data.map((model) => ({
        ...model,
        equipments: equipmentsId,
        zones: zonesId,
        contracts: contractsId
      }))

      commit(SET_MODEL_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_MODEL_ALL_VALUE, editedData)
    } catch (e) {
      commit(SET_MODEL_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_MODEL({ commit }, value) {
    commit(CREATE_MODEL, value)
  },

  async SOCKET_UPDATE_MODEL({ commit }, value) {
    commit(UPDATE_MODEL, value)
  },

  async SOCKET_REMOVE_MODEL({ commit }, id) {
    commit(REMOVE_MODEL, id)
  }
}

const mutations = {
  [SET_MODEL_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_MODEL_ALL_VALUE](state, models) {
    state.all.value = models
  },
  [UPDATE_MODEL](state, updatedModel) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedModel.id }),
      1,
      updatedModel
    )
  },
  [CREATE_MODEL](state, createdModel) {
    state.all.value.push(createdModel)
  },
  [REMOVE_MODEL](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
